import { Component, OnInit, ChangeDetectionStrategy, Inject } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslatePipe } from '../../pipes/translate.pipe';
import {FormControl} from '@angular/forms';
import { BehaviorSubject, combineLatest, Observable, forkJoin } from 'rxjs';
import { map, startWith, mergeMap, switchMap } from 'rxjs/operators';

export type ConfirmDialogResponse = boolean;

interface OptionalParams {
	yesLabel?: string;
	noLabel?: string;
	title?: string;
	translate?: boolean | {
		message?: boolean;
		yesLabel?: boolean;
		noLabel?: boolean;
		title?: boolean;
	};
	yesColor?: ThemePalette;
	noColor?: ThemePalette;
}
export interface NewitemDialogParams extends OptionalParams {
	message: string | string[];
	Categories: string[];
}
export interface DialogData {
  Category: string;

  RawNumber: string;
  Retail: number;
  Item: string;
  Quantity: number;
  Cancelled: boolean;
  Categories: string[];
  isBasket: boolean;
  file;
}
@Component({
	selector: 'app-new-item',
	templateUrl: './new-item-dialog.component.html',
	styleUrls: ['./new-item-dialog.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class NewitemDialogComponent  {
	myControlCategories = new FormControl();
	optionsCategories: string[] = [];
	filteredOptionsCategories: Observable<string[]>;
	constructor(
    public dialogRef: MatDialogRef<NewitemDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {
	}
	
  ngOnInit(){
	  console.log( 'this is the data in ngontint: ',  this.data)
      this.optionsCategories = this.data.Categories
	  this.filteredOptionsCategories = this.myControlCategories.valueChanges.pipe( startWith(''),  map(value => this._filterCategories(value)));
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  private _filterCategories(value: string): string[] {
	if (typeof value === 'string'){
	  return this.optionsCategories.filter(option => option.toLowerCase().includes(value.toLowerCase()));
	} else {
	}
  }

  fileUploaded(event){
  	console.log(event)
  	this.data.file = event
  }

}
